import _ from 'underscore';
import memoize from 'lodash.memoize';
import cloneDeep from 'lodash.clonedeep';

export function formatConversationOnGet(conversation = {}) {
    return cloneDeep(
        _.pick(conversation, ['_id', 'unreadCount', 'lastUpdatedAt', 'type', 'messages', 'participants', 'metadata']),
    );
}

function cloneParticipantsGenerator() {
    let oldArg, cachedResult;

    return function (participants) {
        if (!oldArg || oldArg !== participants) {
            cachedResult = cloneDeep(participants);
            oldArg = participants;
            return cachedResult;
        }

        return cachedResult;
    };
}

const cloneParticipants = cloneParticipantsGenerator();

export const formatConversationOnEvents = memoize((conversation = {}) => {
    const result = _.pick(conversation, ['_id', 'unreadCount', 'lastUpdatedAt', 'type', 'metadata']);
    result.participants = cloneParticipants(conversation.participants);
    return result;
});

export const isValidConversationId = (conversationId) => {
    return typeof conversationId === 'string' && conversationId !== 'default';
};
